
var Share = require("share");

new Share(".share");
new Share(".share-bottom", {
  ui: {
    flyout: "top left"
  }
});

var qsa = function(s) { return Array.prototype.slice.call(document.querySelectorAll(s)) };

var images = qsa("img.fixable");
var dest = document.querySelector(".fixed-frame");
var sections = qsa(".parallax-play");

var dots = document.createElement("ul");
dots.className = "dots";

var indexed = [];

images.forEach(function(img, i) {
  var index = img.parentElement.getAttribute("data-index");
  indexed[index * 1] = img;
  if (!i) img.setAttribute("visible", "");
  dest.appendChild(img);
  var dot = document.createElement("li");
  dot.className = "dot";
  dots.appendChild(dot);
});

dest.appendChild(dots);

var debounce = function(f, d) {
  d = d || 100;
  var timeout = null;
  return function() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    if (timeout) return;
    timeout = setTimeout(function() {
      timeout = null;
      f.apply(null, args);
    }, d);
  };
};

window.addEventListener("scroll", debounce(function(e) {
  var activeDot = dots.querySelector(".active");
  if (activeDot) activeDot.classList.remove("active");
  var lastVisible = 1;

  var current = document.querySelector(".fixed-frame img[visible]");

  for (var i = 1; i < sections.length; i++) {
    var section = sections[i];
    var bounds = section.getBoundingClientRect();
    if (bounds.top > window.innerHeight) {
      break; //leave loop to set new visible image
    }
  }

  var show = indexed[i - 1];
  if (show != current) {
    current.removeAttribute("visible");
    show.setAttribute("visible", "");
  }

  dots.querySelector(".dot:nth-child(" + i + ")").classList.add("active");
}));

document.querySelector("aside.no-mobile-portrait .ok").addEventListener("click", function() {
  document.body.classList.add("hide-warning");
})